import { useEffect, useState } from "react";
import { hasPermission } from "../../shared/permissions";
import { api } from "../api";
import { useSession } from "../App";
import { Banner, messageOf, onSubmit } from "./ui";

type Settings = { business_name: string; sender_name: string | null; sender_email: string | null; intake_address: string | null; timezone: string; currency: string };
type Integrations = Record<string, { status: string; detail: string }>;

const labels: Record<string, string> = {
  access: "Cloudflare Access",
  turnstile: "Turnstile",
  email_inbound: "Εισερχόμενο email",
  email_outbound: "Εξερχόμενο email",
  workers_ai: "Workers AI",
  browser_run: "PDF μέσω Browser Run",
  reservations: "Κρατήσεις",
};

export function SettingsPage() {
  const { user } = useSession();
  const [settings, setSettings] = useState<Settings | null>(null);
  const [integrations, setIntegrations] = useState<Integrations>({});
  const [error, setError] = useState<string | null>(null);
  const [note, setNote] = useState<string | null>(null);
  const canWrite = hasPermission(user.role, user.permissions, "settings.write");

  useEffect(() => {
    api<{ settings: Settings; integrations: Integrations }>("/api/settings")
      .then((result) => {
        setSettings(result.settings);
        setIntegrations(result.integrations);
      })
      .catch((reason: unknown) => setError(messageOf(reason)));
  }, []);

  return (
    <>
      <header className="page-head">
        <div>
          <h1>Ρυθμίσεις στούντιο</h1>
          <p className="lede">Οι υπηρεσίες που δεν έχουν ρυθμιστεί μένουν με ετικέτα. Η τοπική καταγραφή, το πρότυπο εξαγωγής και το PDF με ενσωματωμένη γραμματοσειρά δεν είναι τα ζωντανά προϊόντα της Cloudflare.</p>
        </div>
      </header>
      <Banner error={error} note={note} />
      <div className="grid cards">
        {Object.entries(integrations).map(([key, value]) => (
          <article className="card" key={key}>
            <span>{labels[key] ?? key}</span>
            <b style={{ fontSize: 22 }}>{value.status}</b>
            <span>{value.detail}</span>
          </article>
        ))}
      </div>
      {settings && canWrite ? (
        <form
          className="panel"
          style={{ marginTop: 16 }}
          onSubmit={onSubmit(async (body) => {
            setError(null);
            try {
              await api("/api/settings", { method: "PATCH", body: JSON.stringify(body) });
              setNote("Οι ρυθμίσεις αποθηκεύτηκαν.");
            } catch (reason) {
              setError(messageOf(reason));
            }
          })}
        >
          <h2>Επιχείρηση</h2>
          <div className="fields">
            <label>Ονομα<input name="business_name" defaultValue={settings.business_name} /></label>
            <label>Ονομα αποστολέα<input name="sender_name" defaultValue={settings.sender_name ?? ""} /></label>
            <label>Email αποστολέα<input name="sender_email" defaultValue={settings.sender_email ?? ""} placeholder="Δεν έχει ρυθμιστεί" /></label>
            <label>Διεύθυνση εισαγωγής<input name="intake_address" defaultValue={settings.intake_address ?? ""} placeholder="Δεν έχει ρυθμιστεί" /></label>
          </div>
          <button type="submit">Αποθήκευση</button>
          <p className="meta">{settings.timezone} · {settings.currency}. Μην στρέψεις αυτή τη διεύθυνση σε ζωντανό γραμματοκιβώτιο πριν ρυθμιστεί το Email Routing. Αυτή η εφαρμογή δεν αλλάζει εγγραφές MX.</p>
        </form>
      ) : null}
    </>
  );
}
